import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Toaster } from "sonner";
import "react-toastify/dist/ReactToastify.css";
import DashboardLayout from "./layout/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import ClientList from "./pages/ClientList";
import CreateNew from "./pages/CreateNew";
import UploadDocuments from "pages/UploadDocuments";
import Login from "pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Renewal from "pages/Renewal";
import { canAccessPage } from "./constants/Roles";
import { getCurrentRole } from "./utils/roleUtils";
import "./App.scss";
import UploadDetails from "pages/UploadDetails";
import ParentCode from "pages/ParentCode";
import ThankYou from "pages/ThankYou";
import TatHistory from "pages/TatHistory";

// Wraps a route — redirects to /dashboard if role can't access the page
const RoleRoute = ({ page, children }) => {
  const role = getCurrentRole();
  if (!canAccessPage(role, page)) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route
              path="all-list"
              element={
                <RoleRoute page="all-list">
                  <ClientList />
                </RoleRoute>
              }
            />
            <Route
              path="create-new"
              element={
                <RoleRoute page="create-new">
                  <CreateNew />
                </RoleRoute>
              }
            />
            <Route
              path="Company-and-distributor"
              element={
                <RoleRoute page="parent-code">
                  <ParentCode />
                </RoleRoute>
              }
            />
            <Route
              path="tat-history"
              element={
                <RoleRoute page="tat-history">
                  <TatHistory />
                </RoleRoute>
              }
            />
            <Route
              path="renewal"
              element={
                <RoleRoute page="renewal">
                  <Renewal />
                </RoleRoute>
              }
            />
          </Route>

          <Route path="upload-documents" element={<UploadDocuments />} />
          <Route path="kyc-details" element={<UploadDetails />} />
          <Route path="thank-you" element={<ThankYou />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
